module.exports = __webpack_public_path__ + "img/msu3-char-4.b808989e.png";